module.exports = __webpack_public_path__ + "static/media/ParthPatelResumeOfficial2023.87e9c79c.pdf";